import { render, staticRenderFns } from "./super_sidebar.vue.js?vue&type=template&id=5b27288a&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar.vue?vue&type=template&id=5b27288a&vue3"
import script from "./super_sidebar.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar.vue?vue&type=script&lang=js&vue3"
export * from "./super_sidebar.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports